module.exports = __webpack_public_path__ + "img/service-CRM3.6e4798f9.svg";